import { Box, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material"

import { TestData } from "graphql/types"

type VisualControlProps = {
  setData: (data: TestData) => void
  data: TestData
}

export const VisualControl = (props: VisualControlProps) => {
  const { setData: setTestData, data: testData } = props

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 1,
        alignItems: "center",
      }}
    >
      <Typography>Visuelle Kontrolle</Typography>
      <RadioGroup
        row
        name="Ergebnis der Prüfung"
        value={testData.visualCheck}
        onChange={(e) => setTestData({ ...testData, visualCheck: e.target.value === "true" })}
      >
        <FormControlLabel value={true} control={<Radio />} label="passed" />
        <FormControlLabel value={false} control={<Radio />} label="failed" />
      </RadioGroup>
    </Box>
  )
}
